import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeCarrierShipmentConfig } from './normalize';

export const fetchCarrierShipmentConfig = createProvider(api.fetchCarrierShipmentConfig)
  .andThen((res) => normalizeCarrierShipmentConfig(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch fetchCarrierShipmentConfigList aborted');
    } else {
      console.error('Fetch fetchCarrierShipmentConfigList was failed:', error);
    }
    throw error;
  });
